const FALLBACK = '/img/news-hero-press.png';

export function postCoverUrl(post) {
  if (!post) return FALLBACK;
  return post.cover_image || post.coverImage || post.image || post.thumbnail || FALLBACK;
}

export function postGallery(post) {
  if (!post?.gallery) return [];
  if (Array.isArray(post.gallery)) return post.gallery.filter(Boolean);
  return [];
}

export function postCategoryName(post) {
  if (!post) return 'Geral';
  if (typeof post.category === 'string') return post.category;
  return post.post_categories?.name || post.category?.name || 'Geral';
}
